/**
 * 友達機能フック（Tabitto 用ラッパー）
 */
import {
  useFriends as useFriendsBase,
  useMyFriendCode as useMyFriendCodeBase,
  useAddFriend as useAddFriendBase,
  useRemoveFriend as useRemoveFriendBase,
  useAddFriendsFromGroup as useAddFriendsFromGroupBase,
} from "@tabipla/hooks";
import { apiClient } from "@/infrastructure/api/client";

/**
 * 友達一覧を取得
 */
export function useFriends() {
  return useFriendsBase({ apiClient });
}

/**
 * 自分のフレンドコードを取得
 */
export function useMyFriendCode() {
  return useMyFriendCodeBase({ apiClient });
}

/**
 * 友達を追加（フレンドコードで）
 */
export function useAddFriend(options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  return useAddFriendBase({
    apiClient,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
}

/**
 * 友達を削除
 */
export function useRemoveFriend(options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  return useRemoveFriendBase({
    apiClient,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
}

/**
 * グループメンバーから友達を追加
 */
export function useAddFriendsFromGroup(
  groupId: string,
  options?: { onSuccess?: () => void; onError?: (error: Error) => void }
) {
  return useAddFriendsFromGroupBase({
    apiClient,
    groupId,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
}
